<template>
  <v-card class="main-content" elevation="0">
    <v-card-title class="py-0">
      <api-header />
    </v-card-title>

    <v-card-text>
      <api-generate />
      <api-table />
    </v-card-text>
  </v-card>
</template>

<script>
import ApiHeader from '@/components/api/ApiHeader.vue'
import ApiGenerate from '@/components/api/ApiGenerate.vue'
import ApiTable from '@/components/api/ApiTable.vue'
export default {
  name: 'ApiView',

  components: {
    ApiHeader,
    ApiGenerate,
    ApiTable
  }
}
</script>
